import { DirectiveOptions, VNode } from 'vue'
import { DirectiveBinding } from 'vue/types/options'
import { VBTooltip } from 'bootstrap-vue'

/**
 * Tooltip directive based on bootstrap tooltip directive
 * with hover as default trigger.
 */
export const VVtTooltip: DirectiveOptions = {
    ...VBTooltip, // extends the Bootstrap tooltip directive
    bind: (el: HTMLElement, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) => {
        binding.modifiers.hover = true

        const { bind } = VBTooltip
        if (bind) {
            bind(el, binding, vnode, oldVnode)
        }
    },
    componentUpdated: (el: HTMLElement, binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) => {
        binding.modifiers.hover = true

        const { componentUpdated } = VBTooltip
        if (componentUpdated) {
            componentUpdated(el, binding, vnode, oldVnode)
        }
    }
}
